import { FC } from 'react';
import { Link } from 'atoms/Link/Link';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { Notification } from 'molecules/Notification';
import { useTranslations } from 'modules/i18n/useTranslations';
import { CartActions } from 'modules/shop/cart/types';
import {
  INotification,
  INotificationWithId,
} from 'modules/shop/notificationManager/types';
import { AppRoutes } from 'modules/shop/routes';
import styles from './styles.module.css';

export const getNotificationTKey = (notification: INotification) => {
  const { name, payload } = notification;

  if (name === CartActions.ADD) {
    if (Number(payload?.count) > 1) {
      return CartActions.UPDATE;
    }

    return CartActions.ADD;
  }

  return name;
};
export const TopNotification: FC<{
  notification?: INotificationWithId;
  anchorEl?: HTMLElement | null;
  onClose: () => void;
}> = ({ notification, anchorEl, onClose }) => {
  const t = useTranslations();

  if (!notification || !anchorEl) {
    return null;
  }

  const tKey = getNotificationTKey(notification);

  const productName = notification.payload.name;
  const parsedProductName = <ParseBBCode content={productName || ''} />;

  return (
    <Notification
      open={!!notification}
      id={notification.id}
      anchorEl={anchorEl}
      onClose={onClose}
      disableScrollLock
    >
      {parsedProductName}

      {t.rich(`basket.notification.${tKey}`, {
        count: notification.payload.count,
        strong: (chunks) => <b>{chunks}</b>,
        name: () => parsedProductName,
        link: (chunks) => (
          <Link className={styles.link} href={AppRoutes.CART}>
            {chunks}
          </Link>
        ),
      })}
    </Notification>
  );
};
